export const replaceHostnameInUrl = (url: string, hostname: string): string => {
  const urlObj = new URL(url);
  urlObj.hostname = hostname;

  if (urlObj.pathname === '/') {
    return urlObj.origin;
  }

  return urlObj.href;
};
